import { useContext } from 'react';

import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';

export default function NavList({ data, extraNavItem }) {
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;
  const { productRecord, currentCatalog, isMro, isOversea } = data;

  const navList = (
    <nav role="navigation" aria-label="面包屑导航" className="flex justify-center pt-[16px] text-[14px]">
      <ol className="flex w-[1200px] text-[#54657D] pl-[10px]" data-spm="bc">
        <li className="cursor-pointer after:content-['>'] after:mx-[4px]">
          {isMro ? (
            <a href={projectConfigVO?.lcscMroUrl} data-spm="1">
              首页
            </a>
          ) : (
            <a href={projectConfigVO?.lcscWwwUrl} data-spm="1">
              首页
            </a>
          )}
        </li>
        {currentCatalog?.catalogId != -1 && (
          <li className="after:content-['>'] after:mx-[4px]">
            <a
              href={`${projectConfigVO?.lcscListUrl}/catalog/${currentCatalog?.catalogId}.html${isMro ? '?mro=1' : ''}`}
              data-spm="2"
            >
              {currentCatalog?.catalogName}
            </a>
          </li>
        )}
        {extraNavItem ? (
          <>
            <li className="after:content-['>'] after:mx-[4px]">
              <a data-spm="3" href={`${projectConfigVO?.lcscItemUrl}/${productRecord?.productId}.html`}>
                {productRecord?.productModel}
              </a>
            </li>
            <li aria-current="page">
              <span className="text-[#0093E6]">{extraNavItem}</span>
            </li>
          </>
        ) : (
          <li aria-current="page">
            <span className="text-[#0093E6]">{productRecord?.productModel}</span>
          </li>
        )}
      </ol>
    </nav>
  );

  const overseaNavList = (
    <nav role="navigation" aria-label="面包屑导航" className="flex justify-center mt-[16px] text-[14px]">
      <ul className="flex w-[1200px] text-[#54657D]">
        <li className="after:content-['>'] after:mx-[4px]">
          <a href={projectConfigVO?.lcscWwwUrl} data-spm="1">
            首页
          </a>
        </li>
        {data?.brandId > -1 && (
          <li className="after:content-['>'] after:mx-[4px]">
            <a href={`${projectConfigVO?.lcscListUrl}/brand/${data?.brandId}.html`} data-spm="2">
              {data?.brandName}
            </a>
          </li>
        )}
        <li aria-current="page">
          <span className="text-[#0093E6]">{data?.productCodeManufacturer}</span>
        </li>
      </ul>
    </nav>
  );

  return <>{isOversea ? overseaNavList : navList}</>;
}
